import { getPolygons, getTags } from '@apps/main/modules/api/hotels';

import type {
  ProductStaticInfoMap,
  GetHotelsResponseMap,
  StaticInfoMap,
  OverviewHotel,
  OverviewHotelGetHotelsResponse,
  OverviewDestinationStaticInfo,
  OverviewActivity,
  OverviewActivityStaticInfo,
  OverviewHeartedHotel,
  OverviewHeartedHotelsGetHotelsResponse,
  OverviewHeartedStaticInfo,
  DestinationHotel,
  DestinationGetHotelsResponse,
  DestinationStaticInfo,
  DetailsHotel,
  DetailsGetHotelsResponse,
  DetailsStaticInfo,
  IngredientId,
} from '@libs/trip-planner-interfaces';
import { StaticInfoType } from '@libs/trip-planner-interfaces';

export function createStaticInfo(
  hotel: ProductStaticInfoMap[StaticInfoType.Overview],
  getHotelsResponse: GetHotelsResponseMap[StaticInfoType.Overview],
  ingredientId: IngredientId,
  type: StaticInfoType.Overview
): StaticInfoMap[StaticInfoType.Overview];

export function createStaticInfo(
  hotel: ProductStaticInfoMap[StaticInfoType.OverviewActivity],
  getHotelsResponse: GetHotelsResponseMap[StaticInfoType.OverviewActivity],
  ingredientId: IngredientId,
  type: StaticInfoType.OverviewActivity
): StaticInfoMap[StaticInfoType.OverviewActivity];

export function createStaticInfo(
  hotel: ProductStaticInfoMap[StaticInfoType.OverviewHeartedHotel],
  getHotelsResponse: GetHotelsResponseMap[StaticInfoType.OverviewHeartedHotel],
  ingredientId: IngredientId,
  type: StaticInfoType.OverviewHeartedHotel
): StaticInfoMap[StaticInfoType.OverviewHeartedHotel];

export function createStaticInfo(
  hotel: ProductStaticInfoMap[StaticInfoType.Destination],
  getHotelsResponse: GetHotelsResponseMap[StaticInfoType.Destination],
  ingredientId: IngredientId,
  type: StaticInfoType.Destination
): StaticInfoMap[StaticInfoType.Destination];

export function createStaticInfo(
  hotel: ProductStaticInfoMap[StaticInfoType.Details],
  getHotelsResponse: GetHotelsResponseMap[StaticInfoType.Details],
  ingredientId: IngredientId,
  type: StaticInfoType.Details
): StaticInfoMap[StaticInfoType.Details];

export function createStaticInfo(
  hotel: ProductStaticInfoMap[StaticInfoType],
  getHotelsResponse: GetHotelsResponseMap[StaticInfoType],
  ingredientId: IngredientId,
  type: StaticInfoType
): StaticInfoMap[StaticInfoType] {
  switch (type) {
    case StaticInfoType.Overview: {
      const overviewHotel = hotel as OverviewHotel;
      const overviewHotelResponse =
        getHotelsResponse as OverviewHotelGetHotelsResponse;
      const staticInfoResult: OverviewDestinationStaticInfo = {
        ...overviewHotel,
        ingredientId,
        polygons: getPolygons(
          { polygonIds: overviewHotel.polygonIds ?? [] },
          { polygons: overviewHotelResponse.polygons ?? [] }
        ),
      };
      return staticInfoResult;
    }
    case StaticInfoType.OverviewActivity: {
      const oevrviewActivity = hotel as OverviewActivity;
      const staticInfoResult: OverviewActivityStaticInfo = {
        ...oevrviewActivity,
        ingredientId,
      };
      return staticInfoResult;
    }
    case StaticInfoType.OverviewHeartedHotel: {
      const oevrviewHeartedHotel = hotel as OverviewHeartedHotel;
      const overviewHeartedHotelResponse =
        getHotelsResponse as OverviewHeartedHotelsGetHotelsResponse;
      const staticInfoResult: OverviewHeartedStaticInfo = {
        ...oevrviewHeartedHotel,
        ingredientId,
        polygons: getPolygons(
          oevrviewHeartedHotel,
          overviewHeartedHotelResponse
        ),
      };
      return staticInfoResult;
    }
    case StaticInfoType.Destination: {
      const destinationHotel = hotel as DestinationHotel;
      const destinationHotelResponse =
        getHotelsResponse as DestinationGetHotelsResponse;
      const staticInfoResult: DestinationStaticInfo = {
        ...destinationHotel,
        ingredientId,
        polygons: getPolygons(destinationHotel, destinationHotelResponse),
      };
      return staticInfoResult;
    }
    case StaticInfoType.Details: {
      const detailsHotel = hotel as DetailsHotel;
      const detailsHotelResponse =
        getHotelsResponse as DetailsGetHotelsResponse;
      const staticInfoResult: DetailsStaticInfo = {
        ...detailsHotel,
        ingredientId,
        polygons: getPolygons(detailsHotel, detailsHotelResponse),
        tagIconUrls: getTags(detailsHotel, detailsHotelResponse),
      };
      return staticInfoResult;
    }
    case StaticInfoType.NameOnly:
      throw new Error(
        'StaticInfoType.NameOnly has no StaticInfoMap value associated'
      );
    case StaticInfoType.MainPolygonOnly:
      throw new Error(
        'StaticInfoType.MainPolygonOnly has no StaticInfoMap value associated'
      );
    case StaticInfoType.PositionOnly:
      throw new Error(
        'StaticInfoType.PositionOnly has no StaticInfoMap value associated'
      );
    case StaticInfoType.NeighborhoodPolygonsOnly:
      throw new Error(
        'StaticInfoType.NeighborhoodPolygonsOnly has no StaticInfoMap value associated'
      );
    case StaticInfoType.ActivitySuggestions:
      throw new Error(
        'StaticInfoType.ActivitySuggestions has no StaticInfoMap value associated'
      );
  }
}
